export default __webpack_public_path__ + "images/eea34144583479cf7324cf089966fae5.png";